import React, { useEffect, useState } from "react";
import { array } from "prop-types";

import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./organism1.m.css";

const Organism1 = ({ stories }) => {
  if (!(stories && stories.length)) {
    return null;
  }

  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    setIsDesktop(global.deviceWidth >= 1264);
  }, []);

  return (
    <div styleName={`base`}>
      {stories.map((story, index) => (
        <LeftImageRightNews key={index} story={story} showExcerpt={!!isDesktop} />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
};

export default Organism1;
